<template>
    <BodyGames />
</template>

<script>
import BodyGames from "../components/BodyGames.vue";

export default {
  components: {
    BodyGames
  }
};
</script>
